/**
 * Main App Component
 * Root component with routing and error boundary
 */

import React, { Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ErrorBoundary from './components/ErrorBoundary';
import LoadingSpinner from './components/LoadingSpinner';
import UpdateNotification from './components/UpdateNotification';
import { AppProvider } from './context/AppContext';
import { ROUTES } from './constants';

// Lazy load components for better performance
const HomePage = React.lazy(() => import('./components/HomePage'));
const OrderDetailsPageNew = React.lazy(() => import('./components/OrderDetailsPageNew'));
const NotFound = React.lazy(() => import('./components/NotFound'));

function App() {
  return (
    <ErrorBoundary>
      <AppProvider>
        <Router>
          <Suspense fallback={
            <div className="min-h-screen flex items-center justify-center">
              <LoadingSpinner size="large" text="Loading..." />
            </div>
          }>
            <Routes>
              <Route path={ROUTES.HOME} element={<HomePage />} />
              <Route path={ROUTES.ORDER_DETAILS} element={<OrderDetailsPageNew />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Suspense>
          <UpdateNotification />
        </Router>
      </AppProvider>
    </ErrorBoundary>
  );
}

export default App;
